<template>
    <b-navbar class="site-header" type="light" fixed="top" :sticky="true">
        <b-container>
            <b-navbar-nav class="d-flex flex-column flex-md-row justify-content-between">
                <b-navbar-brand to="/" v-if="!isMobileLayout">
                    <img width="45" :src="require('../assets/img/branding/' + logoName)"/>
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav v-if="user">
                        <b-nav-item to="/"><span v-tr>Home|Accueil</span></b-nav-item>
                        <b-nav-item v-if="!isMobileLayout" to="/account"><span v-tr>My Account|Mon compte</span></b-nav-item>
                    </b-navbar-nav>
                    <b-navbar-nav v-else>
                        <b-nav-item to="/login"><span v-tr>Login|Se connecter</span></b-nav-item>
                        <b-nav-item to="/register"><span v-tr>Register|Inscription</span></b-nav-item>
                    </b-navbar-nav>
                </b-collapse>

                <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template slot="button-content">
                        <template  v-if="user">
    <!--                        <b-avatar width="30" height="30" style="object-fit: cover" icon="people" rounded="circle" class="mr-2" :src="user.avatar_image"></b-avatar>-->
                            <span class="f-500">{{user.email}}</span>
                        </template>
                        <template v-else>
                            <span class="f-500">Menu</span>
                        </template>
                    </template>
                    <template v-if="user">
                        <b-dropdown-item v-if="user" to="/account"><span v-tr>My Account|Mon compte</span></b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                    </template>
                    <b-dropdown-item @click="changeLanguage"><span v-tr>Français|English</span></b-dropdown-item>
                    <b-dropdown-item v-if="user" @click="logout"><span v-tr>Sign Out|Se déconnecter</span></b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-container>
    </b-navbar>
</template>

<script>
    export default {
        name: `app-menu`,
        data() {
            return {}
        },
        methods: {
            changeLanguage() {
                this.$store.commit(`changeLanguage`);
                this.$router.go();
            },
            changeCurrentDealer(dealerid) {
                this.$store.commit(`setDealerid`, dealerid)
            },
            logout() {
                this.$store.dispatch(`logout`)
                    .then(() => {
                        this.$router.push(`/login`)
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .site-header {
        background-color: rgba(white, 0.8);
        backdrop-filter: blur(10px);
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    }

    .navbar {
        .navbar-nav {
            width: 100%;

            .nav-link {
                font-weight: 500;
                letter-spacing: 0.5px;

                &.router-link-exact-active {
                    color: black;
                    border-bottom: 2px solid #000;
                }
            }
        }
    }

    @media(max-width: 576px) {
        .navbar {
            .navbar-nav {
                display: flex !important;
                flex-direction: row !important;

                .navbar-brand {
                    margin: 0;
                    vertical-align: middle;

                    img {
                        max-width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }
</style>
